/**
 * 联系人列表
 * */
import React from 'react';
import Lang from "@components/Lang/Lang";
import { Input } from 'antd';
import TelephoneCode from "@/components/TelephoneCode/TelephoneCode";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import "./index.less"
export default class ContactList extends React.Component {
    static defaultProps = {
        list:[],// 已有联系人
    }
    constructor(props) {
        super(props)
        this.state = {
            // 已有联系人
            list: props.list || [],
            // 空表单项
            inputList:[

            ],
            contactObj:{
                mobile: "",
                name: "",
                telCode: "",
            }
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    onFinish = (values) => {
        console.log('Received values of form:', values);
    };
    add(){
        let { contactObj,inputList } =this.state;
        inputList.push(contactObj)
        this.setState({
            inputList
        })
    }
    /***
     * 清除字段值 | 设置字段)
     */
    setField = (inx,field='',value="",type="") =>{
        if(field){
            const { inputList } =this.state;
            const obj = inputList[inx]||{};
            let newObj = {...obj}
            if(type=="number"&&value){
                value = value.replace(/[^\d]/g,'')
            }
            newObj[field] = value;
            inputList[inx] = newObj
            this.setState({
                inputList: inputList
            })
        }
    }
    handleOK(){
        const { inputList=[],list } =this.state;
        const resList = inputList.filter(item=>item.mobile&&item.name); //两者均有值才保存
        return [...list,...resList]
    }
    // 删除 联系人数据
    deleteState(id){
        const { list=[] } =this.state;
        const newList = list.filter(item=>item.id!=id)
        this.setState({
            list: newList||[]
        })
    }
    componentDidMount(){
        this.add();
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const { inputList,list } =this.state;
        const num = (inputList.length||0) + (list.length||0);
        return (<div className={"contactWrap"}>
            {/* 已有列表 */}
            {list.length>0&&<>
                {list.map((item,inx)=>{return(<div className={"lineRow flex-item-between font_14"} key={inx}>
                    <div className={"black89 fw_500"}>{item.name}</div>
                    <div className={"black45"}>
                        +<span className={"ml_2"}>{item.telCode}</span>
                        <span className={"ml_4 mr_6"}>{item.mobile}</span>
                        <AuthBtn icon={"ri-delete-bin-line"} tips = {Lang({id:"ShanChu",default:"删除"})} onClick={()=>this.deleteState(item.id)}/>
                    </div>
                </div>)})}
            </>}
            {/* 新增列表 */}
            {num<=10&&inputList.length>0&&<div className={"lineTop pt_12"}>
                {inputList.map((item,inx)=>{return(<div className={"flex-item-ver-center mb_12"} key={inx}>
                    <Input onChange={(e)=>this.setField(inx,"name",e.target.value)}
                           value={item.name}
                           className={"mr_10"}
                           placeholder={Lang({id: "LianXiRenXingMing",default: "联系人姓名"})} />
                    <Input addonBefore={<TelephoneCode onItemClicked={(data)=>this.setField(inx,"telCode",data)} />}
                           onChange={(n)=>this.setField(inx,"mobile",n.target.value,"number")}
                           value={item.mobile}
                           placeholder={Lang({id: "DianHua",default: "电话"})}  />
                </div>)})}
            </div>}
            {num<10&&<div className="lineTop color-danger flex-item-ver-center cursor-p pt_4" onClick={()=>this.add()}>
                <i className="ri-add-circle-line mr_4 font-18"></i>
                <span className="font_14">{Lang({id: "XinZengLianXiRen",default: "新增联系人"})}</span>
            </div>}
        </div>);
    }
};
